export default {
  green: ['#37bc9b', '#48cfad'],
  yellow: ['#f6bb42', '#ffce54'],
  aqua: ['#3bafda', '#4fc1e9'],
  purple: ['#967adc', '#ac92ec'],
  pink: ['#d770ad', '#ec87c0'],
  blue: ['#4a89dc', '#5d9cec'],
  gray: ['#999', '#ccc']
}
